import { TRAILING_CURRENCY_CODE_PX, TRAILING_DECO_PX } from './composables/inputTrailingZone';

export type CurrencyDecoration = {
  code: string;
  label: string;
  reservePx: number;
};

export function currencyDecoration(
  currency: string | undefined,
  locale: string
): CurrencyDecoration {
  const raw = (currency ?? 'EUR').trim().toUpperCase();
  const code = /^[A-Z]{3}$/.test(raw) ? raw : 'EUR';
  let label = code;

  try {
    label =
      new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: code,
        currencyDisplay: 'symbol',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      })
        .formatToParts(0)
        .find((part) => part.type === 'currency')?.value ?? code;
  } catch {
    // Keep the valid ISO code when the runtime does not know the currency.
  }

  return {
    code,
    label,
    reservePx: Array.from(label).length === 1 ? TRAILING_DECO_PX + 6 : TRAILING_CURRENCY_CODE_PX,
  };
}
